module.exports = __webpack_public_path__ + "img/number-one-world.841fc563.jpg";